import { Grid } from "@mui/material";

export default function LoreTab() {
  return (
    <Grid container spacing={2}>
      <div>
        <h2>The Beginning: Neutron Genesis</h2>
        <p>
          It all starts with the humble Neutron, the seed of creation in this
          grand scheme. These neutral particles, abundant yet elusive, serve as
          the primary resource in the Particle Synthesizer. By harnessing the
          power of Neutrons, we unlock the potential to create, to build, and to
          innovate beyond the limits of traditional science. The Neutron, in its
          simplicity, produces particles - the very essence of matter and the
          first step towards complexity.
        </p>

        <h2>The Ascension: From Atom to Super AI</h2>
        <p>
          As the Neutron seeds particles, the journey of production begins to
          escalate. Atoms form the foundation of matter, crafted meticulously by
          the particles themselves. These atoms are then harnessed by Microbots,
          tiny architects of the microscopic world, laying down the structure
          for more complex creations.
        </p>
        <p>
          The leap from the physical to the digital is bridged by the Weak AI, a
          nascent form of intelligence capable of rudimentary decision-making
          and automation. This paves the way for the creation of Nanobots,
          sophisticated machines that work at the atomic level to refine and
          enhance the production process.
        </p>
        <p>
          With the advent of Strong AI, the system gains the ability to learn,
          adapt, and optimize itself, transcending the limitations of its
          creators. The Quantum Assembler, a marvel of this new era, utilizes
          principles of quantum mechanics to fabricate materials with properties
          that defy conventional physics.
        </p>
        <h2>The Creation: Molecules and Beyond</h2>
        <p>
          Amidst this cascade of production, the synthesis of molecules
          represents a significant milestone. Through the accumulation of
          particles, we gain the ability to construct molecules, the building
          blocks of everything around us. This capability unlocks a new realm of
          possibilities, from the creation of simple water molecules (H2O) to
          the complex structures of carbon dioxide (CO2) and beyond. Each
          molecule crafted opens the door to new upgrades and enhancements,
          fueling the cycle of creation and discovery.
        </p>

        <h2>The Legacy: A New Dawn</h2>
        <p>
          In this world of endless potential, you stand at the helm of
          humanity's greatest endeavor. Each producer you command, from the
          Neutron to the Super AI, represents a step towards a future where the
          limitations of the physical world are but a distant memory. As you
          unlock the secrets of the universe, molecule by molecule, you pave the
          way for a future where humanity's survival is not tied to the whims of
          nature, but to the boundless creativity and ingenuity of its people.
        </p>
        <p>
          Welcome to the dawn of a new era, where the fabric of reality itself
          is yours to weave.
        </p>
      </div>
    </Grid>
  );
}
